interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
  size?: number;
}

export const DoubleArrowIcon = ({
  size,
  width,
  height,
  fill = "white",
}: IconProps) => {
  return (
    <svg
      width={width || size || 25}
      height={height || size || 26}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7497 10.9157C18.7497 10.6395 18.64 10.3745 18.4446 10.1792C18.2493 9.9838 17.9843 9.87405 17.7081 9.87405H5.63515L8.03099 7.48864C8.22714 7.29249 8.33733 7.02645 8.33733 6.74905C8.33733 6.47166 8.22714 6.20562 8.03099 6.00947C7.83484 5.81332 7.5688 5.70313 7.29141 5.70312C7.01401 5.70312 6.74797 5.81332 6.55182 6.00947L2.38516 10.1761C2.24062 10.3226 2.1427 10.5086 2.10377 10.7107C2.06484 10.9128 2.08663 11.1219 2.16641 11.3116C2.24455 11.5018 2.37726 11.6646 2.5478 11.7796C2.71834 11.8945 2.91909 11.9564 3.12474 11.9574H17.7081C17.9843 11.9574 18.2493 11.8476 18.4446 11.6523C18.64 11.4569 18.7497 11.192 18.7497 10.9157ZM22.8331 14.6866C22.7549 14.4963 22.6222 14.3335 22.4517 14.2186C22.2811 14.1036 22.0804 14.0417 21.8747 14.0407H7.29141C7.01514 14.0407 6.75019 14.1505 6.55484 14.3458C6.35949 14.5412 6.24974 14.8061 6.24974 15.0824C6.24974 15.3587 6.35949 15.6236 6.55484 15.819C6.75019 16.0143 7.01514 16.1241 7.29141 16.1241H19.3643L16.9685 18.5095C16.8709 18.6063 16.7934 18.7215 16.7405 18.8485C16.6876 18.9754 16.6604 19.1115 16.6604 19.2491C16.6604 19.3866 16.6876 19.5227 16.7405 19.6497C16.7934 19.7766 16.8709 19.8918 16.9685 19.9886C17.0653 20.0863 17.1805 20.1638 17.3075 20.2166C17.4344 20.2695 17.5706 20.2968 17.7081 20.2968C17.8456 20.2968 17.9817 20.2695 18.1087 20.2166C18.2356 20.1638 18.3508 20.0863 18.4477 19.9886L22.6143 15.822C22.7589 15.6755 22.8568 15.4895 22.8957 15.2874C22.9346 15.0853 22.9128 14.8763 22.8331 14.6866Z"
        fill={fill}
      />
    </svg>
  );
};

export default DoubleArrowIcon;
